import React from "react";
import Story from "../../layouts/Story";
import BeeSwarm from "./charts/BeeSwarm";
import Binary from "./charts/Binary";
import CorrelationChart from "./charts/CorrelationChart";
import { Image } from "./../../components/Elements";
import Boxes from "./charts/Boxes";
import Pathways from "./charts/Pathways";
const copy = require(`./copy/${process.env.REACT_APP_LANG}`);

const StoryTwo = () => {
  const additionalComponents = {
    beeSwarm: (props) => <BeeSwarm {...props} countries={copy.countries} />,
    binary: (props) => (
      <Binary
        {...props}
        countries={copy.countries}
        regions={copy.regions}
        incomeGroups={copy.incomeGroups}
      />
    ),
    correlationChart: (props) => (
      <CorrelationChart {...props} countries={copy.countries} />
    ),
    image: Image,
    boxes: Boxes,
    pathways: Pathways,
  };

  return <Story {...copy} additionalComponents={additionalComponents} />;
};

export default StoryTwo;
